module.exports = __webpack_public_path__ + "static/wrapped-goggles-db14fa623db08956f5f0ce85c8ab0848.png";